import { useQuery } from "@tanstack/react-query"
import { TrainingCourseGet } from "../app/models/TrainingCourse"
import { digitalManagerApi } from "../services/api"

export function useTrainingCourses(trainingId?: string) {
  const { data: trainingCourses = [], isLoading: isLoadingTrainingCourses } = useQuery({
    queryKey: ["trainingCourses", trainingId],
    queryFn: () =>
      digitalManagerApi
        .get<TrainingCourseGet[]>(`/trainings/${trainingId}/courses`)
        .then((r) => r.data),
    enabled: !!trainingId,
  })

  return {
    trainingCourses,
    isLoadingTrainingCourses,
  }
}
